import { AlertTriangle } from "lucide-react";

export function DisclaimerBar({
  className = "",
  icon: Icon = AlertTriangle,
  variant = "warning",
  title = "JCC is not a care agency.",
  description = "We do not employ, supply, vet, manage, supervise or guarantee carers. Everything here is guidance and structure to help you make safer, clearer independent arrangements.",
}) {
  const styles = variant === "info"
    ? "border-teal-200 bg-teal-50 text-ink"
    : "border-amber-200 bg-amber-50 text-amber-900";
  return (
    <div className={`flex items-start gap-3 rounded-2xl border p-4 text-sm ${styles} ${className}`} data-testid="disclaimer-bar">
      <Icon className={`w-5 h-5 mt-0.5 shrink-0 ${variant === "info" ? "text-teal" : ""}`} strokeWidth={1.75} />
      <span>
        <strong className="font-semibold">{title}</strong> {description}
      </span>
    </div>
  );
}

export function SectionHeading({ eyebrow, title, description, align = "left", accent = "teal" }) {
  const accentClass = accent === "purple" ? "text-purple" : "text-teal";
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <div className={`overline ${accentClass} mb-3`}>{eyebrow}</div>}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.1] tracking-tight">{title}</h2>
      {description && <p className="mt-4 text-base md:text-lg text-ink-muted leading-relaxed">{description}</p>}
    </div>
  );
}

export function PageHero({ eyebrow, title, description, accent = "teal", children, bgTint = "light" }) {
  const bgClass = bgTint === "carer" ? "bg-surface-carer" : bgTint === "family" ? "bg-surface-family" : "bg-white";
  return (
    <section className={`${bgClass} border-b border-slate-100`}>
      <div className="container-jcc py-16 md:py-24 lg:py-28">
        {eyebrow && <div className={`overline mb-4 ${accent === "purple" ? "text-purple" : "text-teal"}`}>{eyebrow}</div>}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-4xl">{title}</h1>
        {description && <p className="mt-5 text-lg md:text-xl text-ink-muted leading-relaxed max-w-3xl">{description}</p>}
        {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
      </div>
    </section>
  );
}
